/**
 * Homeowner renewal reminders, sponsor soft-landing emails, the deletion
 * confirmation, and the 60-day account deletion.
 * Unset BILLING_NOTICES_LIVE keeps every one of those on delivered+tag@resend.dev
 * and does not delete a real account. 1, true, on, or yes sends to the
 * address on the account and allows that deletion.
 * CommonJS only. No object spread.
 */

function envSource(env) {
  if (env) return env;
  if (typeof process !== 'undefined' && process.env) return process.env;
  return {};
}

function billingNoticesLive(env) {
  const value = String(envSource(env).BILLING_NOTICES_LIVE || '').trim().toLowerCase();
  return value === '1' || value === 'true' || value === 'on' || value === 'yes';
}

function testInbox(email) {
  return /^delivered\+[a-z0-9._-]+@resend\.dev$/.test(email);
}

function billingNoticeRecipient(email, env) {
  const value = String(email || '').trim().toLowerCase();
  if (!value || value.indexOf('@') === -1) return '';
  if (billingNoticesLive(env)) return value;
  if (testInbox(value)) return value;
  return '';
}

module.exports = {
  billingNoticesLive,
  billingNoticeRecipient,
};
